(function() {
	'use strict';

	/**
	* @memberof app
	* @ngdoc controller
	* @name DatosController
	* @description
	* This is main controller
	**/

	angular
		.module('app')
		.controller('DatosController', DatosController);

	DatosController.$inject = ["$sce", "$timeout", "$location", '$window', 'DatosService', '$scope'];

	function DatosController($sce, $timeout, $location, $window, DatosService, $scope) {
		var vm = this;
		vm.filtros = {};
		vm.categoria_post = "";
		$scope.categoria_post = vm.filtros.categoria_post;
		vm.numPaginas = 0;
		vm.page = 0;
		vm.loading = false;
	    vm.items = 0;
	    
		vm.renderTitle = function(title) {
			return $sce.trustAsHtml(title);
		};

		vm.resultlist = function(callback) {
			vm.loading = true;
			DatosService.getResult(vm).then(function(data) {
				vm.result = data.result;

				vm.loading = false;
			}, function(data) { });
		}

		vm.showPost = function(init) {
			vm.loading = true;
			DatosService.getPost(vm.filtros, vm).then(function(data) {
				vm.post = data.post;
				vm.categoriaspost = data.categoriaspost;
				vm.numPaginas = data.numPaginas;
				vm.loading = false;
				vm.items = data.items;
			});
		}

		vm.next = function() {
			vm.page++;
			vm.showPost();


			scrollToTop();
		};

		vm.prev = function() {
			vm.page--;
			vm.showPost();
			scrollToTop();
		};

		vm.resetFilters = function() {
			$timeout(function() {
				vm.filtros.categoria_post = {};
				$scope.categoria_post = vm.filtros.categoria_post;
				vm.filtros.categoria_post["todos"] = true;
			});
		}

		$scope.$watch("categoria_post", function(newValue, oldValue) {
			//console.log(newValue);

			var b = false;
			angular.forEach(newValue, function(item) {
				if (item) {
					b = true;
				}
			});
			if (!b)
				vm.resetFilters();

			return true;

		}, true);

		function scrollToTop() {
			// Esperamos un poquito para que se cargue el contenido
			setTimeout(function() {
				const el = document.getElementById('scrollPosts');
				if (el) {

					el.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}, 100);
		}




	}

})();
